<template>
  <div class="ctn-user-search">
    <v-container>
      <v-row class="justify-left">
        <v-card style="padding: 8px 12px; width: 100%;">
          <div 
            class="justify-space-between mb-2 d-flex"> 
            <div>
              <v-btn
                color="teal" dark text x-small 
                @click="goToPage(tableUsers.users.prev_page_url)"
                style="width: auto;"
                class="close-profile" v-if="tableUsers.users.prev_page_url">
                <v-icon small>mdi-chevron-left</v-icon> Anterior
              </v-btn>
            </div>
            <div>
              <v-btn
              color="teal" dark text x-small 
              @click="goToPage(tableUsers.users.next_page_url)"
              style="width: auto;"
              class="close-profile"  v-if="tableUsers.users.next_page_url">
              Siguiente <v-icon small>mdi-chevron-right</v-icon> 
              </v-btn>
            </div>
          </div>
					<v-simple-table class="table-styled" v-if="tableUsers.users.data">
						<template v-slot:default>
								<thead>
								<tr>
								<th class="text-left">Correo</th>
								<th class="text-left">Nombre</th>
								<th class="text-center">Acciones</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="data in tableUsers.users.data" :key="data.id">
								<td>
										{{ data.email }}
								</td>
								<td>{{ data.user_data.display_name }}</td>
								<td class="btn-size-auto">
										<v-btn class="ma-2" color="primary" @click="showEdit(data.id)">
										Editar
										<v-icon small right>mdi-pencil</v-icon>
										</v-btn>
								</td>
								</tr>
								</tbody>
						</template>
					</v-simple-table>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UsersTable.vue",
  data() {
    return {
      tableData: [],
    };
  },
  props: ["searchUser"],
  computed: {
    ...mapState("user", ["tableUsers","currentUser"]),
  },
  watch: {
    searchUser() {
      this.tableSearch(this.searchUser)
      console.log('==>', this.searchUser)
    }
  },
  methods: {
    ...mapActions("user", [
      "getAllUsers",
      "updateCurrentUser"
    ]),
    ...mapActions(["loaderChange"]),
    showEdit(id) {
        this.updateCurrentUser(id);
        this.$emit("changeUser");
    },
    goToPage(url) {
      url = url + (this.searchUser ? `&searchUser=${this.searchUser}` : '')
      let data = {
        "url": url
      }
      this.loaderChange(true)
      this.getAllUsers(data).then(()=> {
        this.loaderChange(false)
      })
    },
    tableSearch(search) {
      let data = {
        "search": search
      }
      this.loaderChange(true)
      this.getAllUsers(data).then(()=> {
        this.loaderChange(false)
      })
    }
  },
  mounted() {
      this.loaderChange(true)
      this.getAllUsers().finally(()=> {
        this.loaderChange(false)
      })
  }
};
</script>

<style scoped>
.btn-size-auto {
  text-align: center;
}
::v-deep .th.text-left:last-child {
  text-align: center !important;
}
</style>
